(function() {   

    function getParamFromUrl(sParam) {
        let sPageURL = window.location.search.substring(1),
          sURLVariables = sPageURL.split('&'),
          sParameterName,
          i;
      
        for (i = 0; i < sURLVariables.length; i++) {
          sParameterName = sURLVariables[i].split('=');
      
          if (sParameterName[0] === sParam) {
            return sParameterName[1];
          }
        }
      
        return null;
      }

    function onDocumentReady() {
        if(document.getElementById('queryparams-sessionstorage')) {
            //Get list of queryparams from html
            let queryParamsSet = document.getElementById('queryparams-sessionstorage').value;
            let queryParams = queryParamsSet.split(",");

            queryParams.forEach(queryParamName => {
                queryParamName = queryParamName.trim();
                let queryParamValue = getParamFromUrl(queryParamName);

                //Does the queryParam exists in the URL
                if(queryParamValue) {

                    //If this specific query param is not in the session storage, stores it
                    if(!sessionStorage.getItem(queryParamName)) {
                        sessionStorage.setItem(queryParamName, queryParamValue);
                    }
                }
                 //adding hidden html tags for each queryParamName
                 document.getElementsByClassName('session-storage')[0].querySelector(`input[name=${queryParamName}]`).value= sessionStorage.getItem(queryParamName);
            });
        }
    }

    if (document.readyState !== "loading") {
        onDocumentReady();
    } else {
        document.addEventListener("DOMContentLoaded", onDocumentReady);
    }

})();